<template>
  <div class="col s12" v-cloak>
    <div class="col s12 m12 l8">
      <div class="col s12 m12 l12">
        <audio id="sound" style="display: none;" allow="audio" preload="auto" controls="none">
          <source src="../../../static/sound/move.mp3" type="audio/mpeg">
        </audio>
        <!--<div class="col s1 m1 l1">
          <img style="height: 60px;" src="../../../static/images/pieces/merida/wP.svg" alt="">
        </div>-->
        <div v-if="!isHumanVsAnalisis()">
          <blockquote class="chip pulse col s5 m5 l5" style="text-align: left; overflow: hidden; white-space:nowrap; text-overflow:ellipsis;" v-bind:class="[turn === 'white' & times.white > 0 ? 'purple darken-4 userTurn' : '']">
            <span class="float: right">{{ times.white | timeBoard }}</span>
            <b class="" v-if="boardShow !== undefined">{{ boardShow.u1 }}</b>
          </blockquote>

          <div class="col s2 m2 l2" style="text-align: center;">
            <h5 class="flat-text-header" style="position: relative; top: 15px;">vs</h5>
          </div>
          <blockquote class="chip pulse col s5 m5 l5" style="text-align: left; overflow: hidden; white-space:nowrap; text-overflow:ellipsis;" v-bind:class="[turn === 'black' & times.white > 0 ? 'purple darken-4 userTurn' : '']">
            <span class="" style="float:right">{{ times.black | timeBoard}}</span>
            <b class="">{{ boardShow !== undefined ? boardShow.u2 : '' }}</b>

          </blockquote>
          <!--<div class="col s1 m1 l1">
            <img class="orange" style="height: 60px;float:right;" 
                src="../../../static/images/pieces/merida/bP.svg" alt="">
          </div>-->
        </div>
        <div v-else>
          <blockquote class="chip pulse col s12 m12 l12 " style="text-align: right;">
            <b class="" v-if="boardShow !== undefined && boardShow.u1">ANALISIS de {{ boardShow.u1 }}</b>
          </blockquote>
        </div>
      </div>
      <div class="col s12 m12 l12">
        <div id="middle" class="boardmiddle">
          <div class="loadbar" id="analisisVertical" style="display:none">
            <strong id="myBar2" class="bar"></strong>
          </div>  
          <div id="pgnBoard" style="width: 100%;height: 460px;float:left;" :class="classboard">
          </div>
        </div>
      </div>
    </div>
    <div class="col s12 m12 l4" id="history">
      <blockquote v-if="!isHumanVsAnalisis() && (board && board.wins) || (result && result.wins)">
        <b v-if="board.wins || result.wins">{{ $t("visor.result") }}: </b>
        <div class="chip">
          {{ $t("game.wins") }} {{ (board.wins==='white')? 'blancas': 'negras'}} {{ $t("visor.by") }}
                          {{ (board.motiv==='rendicion')? 'rendición': ((board.motiv==='timeout')? 'tiempo': ((board.motiv==='checkmate')? 'jaque mate': board.motiv)) }}
        </div>
      </blockquote>
      <pgn-header-card :pgn="myPGNValue" :show-metadata="true" compact></pgn-header-card>
      <!--<div id="pgnHeader"></div> -->
      <div id="pgnComment" style="display:none;"></div>
      <div id="pgnButtons"></div>
      <div id="pgnError"></div>
      <div id="pgnMovesEvents"></div>
      
      <blockquote style="display:none;" ><b class="flat-text-header">PGN: </b><input id='myPGNValue' v-model.lazy="myPGNValue" /></blockquote>
      <blockquote style="display:none;" ><b class="flat-text-header">PGN: </b><input id='myPGNReload' v-model.lazy="myPGNReload" /></blockquote>
      <blockquote style="display:none;" ><b class="flat-text-header">TimeW: </b><input id='myPGNTimeW' v-model.lazy="myPGNTimeW" /></blockquote>
      <blockquote style="display:none;" ><b class="flat-text-header">TimeB: </b><input id='myPGNTimeB' v-model.lazy="myPGNTimeB" /></blockquote>

      <!--<blockquote><b class="flat-text-header">PGN: </b><input id='myPGNValue' v-model.lazy="myPGNValue" /></blockquote>-->
      <blockquote style="display:none;" ><b class="flat-text-header">FEN: </b><input id='myFENValue' v-model.lazy="myFENValue" /></blockquote>
      <!--<blockquote><b class="flat-text-header">PGN: </b><p id='myPGNValue'></p></blockquote>-->
      <blockquote style="display:none;"><b class="flat-text-header">FEN: </b><span id='myFENValueP'></span></blockquote>
      <board-history v-if="validBoard" :pgn="myPGNValue" :fen="myFENValue" :history="history" :userchat="userChat" :user="user" :humanvsanalisis="isHumanVsAnalisis" :board="board" :events="true"></board-history>
      
    </div>
  </div>
</template>
<script>
import Chess from 'chess.js'
import UserService from '../../services/user'
import Store from '../../services/lstorage'
// import Chessground from 'chessground'
// import Garbochess from '../../services/garbochess.js'
// import UserService from '../../services/user'
import BoardHistory from '../game/boardHistory'
import toast from 'vue-material-components'
import PgnHeaderCard from '../common/PgnHeaderCard.vue'
// import Jquery from 'jquery'
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}
var timesColor = {
  white: 1,
  black: 1
}
window.pgn = ''
window.ground = 0
window.pgnBoardBase = 0
window.computerGame = 1
window.orientationg = 'white'
export default {
  name: 'boardVisorEvents',
  props: {
    board: {
      type: Object
    },
    classboard: {
      type: String
    }
  },
  computed: {
    validBoard () {
      return Array.isArray(this.board) ? null : this.board
    }
  },
  data () {
    return {
      result: {},
      boardShow: {},
      history: [],
      chess: new Chess(),
      turn: '',
      userFrom: '',
      fen: '',
      times: {
        black: 4800,
        white: 4800,
        incremento: 30
      },
      styleboard: true,
      stylesBoard: stylesBoard,
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        }),
      user: UserService.user,
      myFENValue: '',
      myPGNValue: '',
      myPGNTimeW: '',
      myPGNTimeB: '',
      userChat: UserService.user.name,
      classBoard: ''
    }
  },
  components: {
    BoardHistory,
    PgnHeaderCard
  },
  mixins: [
    toast
  ],
  events: {
    move (board) {
      if (this.boardShow !== undefined && this.boardShow._id === board.idBoard) {
        if (document.getElementById('searchInput') && document.getElementById('analisisModal').style.display !== 'none') {
          // document.getElementById('searchInput').value = window.pgnBoardBase.chess.fen()// window.pgnBoardBase.getPgn().write_pgn()
          document.getElementById('searchInput').value = window.pgnBoardBase.getPgn().write_pgn()
          document.getElementById('searchInput').dispatchEvent(new window.Event('change'))
        }
        // console.log('Home move from ' + board.user.username)
        // console.log('Game move to ' + this.boardShow.u1)
        document.body.dispatchEvent(new window.Event('chessground.resize'))
        if (board.user !== undefined) {
          if (this.boardShow !== undefined && this.boardShow.wins && board.idBoard || board.user.username === this.user.username ||
          board.user.username !== this.boardShow.u1) {
            return
          }
          // window.alert(board.user.username + ' ' + this.boardShow.u1)
          this.userFrom = board.user.username
          // this.historyChange = false
          // if (board.idBoard) {
          //   this.historyChange = true
          // }
          // window.alert('boardmove')
        }
        this.changeStateGame(board)
        if (board.times) {
          this.times = board.times
        }
      }
    },
    gameFinish (dataResult) {
      this.stateFinishGame(dataResult)
    },
    sendPGNtoTeacher () {
      // var idTextArea = document.getElementById('idTextAreaPGN')
      // if (idTextArea && idTextArea.value !== 'none') {
      // window.alert('changePGN: ' + this.myPGNValue + ' FEN - ' + this.myFENValue)
      // comunicacion con servidor
      // console.log(UserService.getUser().username)
      // console.log(this.boardShow.u1)
      var turn = (this.chess.turn() === 'w') ? 'white' : 'black'
      var data = {
        c: 'board',
        f: 'move',
        data: {
          event: 'move',
          data: {
            pgn: this.myPGNValue,
            fen: this.myFENValue,
            idBoard: this.boardShow._id,
            turn: turn,
            times: {},
            user: UserService.getUser()
          }
        }
      }
      // window.alert(JSON.stringify(data.data))
      // this.$dispatch('move', {pgn: this.myPGNValue})
      this.$socket.emit('event', data, function (...callbacks) {
          // console.log(callbacks)
      })
      this.userFrom = this.user.username
    },
    analizaPGN () {
      this.$broadcast('modal::open', 'invitePCAnalisis')
    }
  },
  methods: {
    soundPlay () {
      var sonido = document.getElementById('sound')
      if (sonido) {
        sonido.play()
      }
    },
    onResize (event) {
      if (document.getElementById('middle') && document.getElementById('pgnBoard')) {
        var Width = document.getElementById('middle').clientWidth
        Width = Width > window.innerHeight - 150 ? window.innerHeight - 150 : Width // document.getElementById('middle').clientWidth
        var winWidth = Math.min(window.innerWidth, window.outerWidth)
        var Left = 0
        var LeftAnalisis = 0
        if (winWidth >= 782) {
          Width = window.innerHeight - 160 < Width ? window.innerHeight - 160 : Width
          if (Width < document.getElementById('middle').clientWidth) {
            var rightMore = document.getElementById('middle').clientWidth - Width
            // window.alert(rightMore)
            Left = rightMore / 2 + 'px'
            LeftAnalisis = (rightMore / 2) - 3 + 'px'
          }
        }
        if (document.getElementById('analisisVertical') && document.getElementById('analisisVertical').style.display !== 'none') {
          Width = Width - 20
        }
        document.getElementById('pgnBoard').style.left = Left
        document.getElementById('pgnBoard').style.height = Width + 'px'
        document.getElementById('pgnBoard').style.width = Width + 'px'
        document.getElementById('analisisVertical').style.left = LeftAnalisis
        document.getElementById('analisisVertical').style.height = Width + 6 + 'px'
        // Jquery('#pgnBoard').load(window.location.href + '#pgnBoard')
        // this.toast('<span>Width: ' + Width + '</span>', 2000, 'rounded')
        document.body.dispatchEvent(new window.Event('chessground.resize'))
      }
    },
    changeOrientation () {
      // window.ground = Chessground(document.getElementById('boardInner'))
      window.orientationg = window.orientationg === 'white' ? 'black' : 'white'
      window.ground.set({
        orientation: window.orientationg,
        drawable: {
          enabled: true,
          visible: true
        }
      })
    },
    isHumanVsAnalisis () {
      return (this.board !== undefined && this.board.u1 === this.board.u2)
    },
    stateFinishGame (state) {
      if (state.board._id === this.board._id) {
        this.result = {
          wins: state.result.color,
          motiv: state.result.motiv
        }
        clearInterval(timesColor.black)
        clearInterval(timesColor.white)
      }
    },
    deleteComment (pgn) {
      // pgn = pgn.replace(/\{(.*?)\}/gmu, '')
      pgn = pgn.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
      // pgn = pgn.replace(/\{(\s\S.+?)\}/gmu, '')
      return pgn
    },
    changeStateGame (board) {
      if (board === undefined || board.pgn === '' || board.pgn === 'none') {
        return
      }
      // board.pgn = this.deleteComment(board.pgn)
      // this.soundPlay()
      // window.pgn = board.pgn
      // window.alert(board.pgn)
      // this.fen = this.myFENValueP // this.chess.fen()
      // this.chess.load_pgn(board.pgn)
      // console.log(this.chess.undo())
      /* if (board.move) {
        window.ground.move(board.move.from, board.move.to)
      }
      window.ground.set({
        fen: this.chess.fen(),
        orientation: window.orientationg,
        drawable: {
          enabled: true,
          visible: true
        }
      })*/
      // window.alert(board.fen)
      this.chessToColor(this.chess)
      // if (this.historyChange) {
      //   this.history = this.chess.history({ verbose: true })
      // }

      if (document.getElementById('pgnMovesEvents')) {
        document.getElementById('pgnMovesEvents').textContent = ''
      }
      if (document.getElementById('pgnButtons')) {
        document.getElementById('pgnButtons').textContent = ''
      }
      if (document.getElementById('pgnComment')) {
        document.getElementById('pgnComment').textContent = ''
      }
      /* if (document.getElementById('pgnHeader')) {
        document.getElementById('pgnHeader').textContent = ''
      } */
      if (document.getElementById('pgnError')) {
        document.getElementById('pgnError').textContent = ''
      }
      var Width = document.getElementById('middle').clientWidth
      Width = Width > window.innerHeight - 150 ? window.innerHeight - 150 : Width // document.getElementById('middle').clientWidth
      var winWidth = Math.min(window.innerWidth, window.outerWidth)
      var Left = 0
      var LeftAnalisis = 0
      if (winWidth >= 782) {
        Width = window.innerHeight - 160 < Width ? window.innerHeight - 160 : Width
        if (Width < document.getElementById('middle').clientWidth) {
          var rightMore = document.getElementById('middle').clientWidth - Width
          // window.alert(rightMore)
          Left = rightMore / 2 + 'px'
          LeftAnalisis = (rightMore / 2) - 3 + 'px'
        }
      }
      if (document.getElementById('analisisVertical') && document.getElementById('analisisVertical').style.display !== 'none') {
        Width = Width - 20
      }
      var pgnBoard = 0
      /* var start = ''
      if (board.fen !== undefined) {
        start = board.fen
      } else {
        start = ''
      }*/
      var pos = ''
      if (board.fen !== undefined) {
        pos = board.fen
      } else {
        pos = ''
      }
      if (pos === 'start') {
        pos = ''
      }
      // this.toast('<span>' + board.pgn + '</span>', 10000, 'rounded')
      // this.toast('<span>' + pos + '</span>', 2000, 'rounded')
      if (board.pgn !== 'none') {
        pgnBoard = window.pgnEdit({inner: 'pgnBoard', moves: 'pgnMovesEvents', comment: 'pgnComment', button: 'pgnButtons', fen: 'pgnFen', error: 'pgnError'}, {pgn: board.pgn, startPlay: pos, position: 'end', width: Width, locale: 'es', orientation: 'white' /* window.orientationg */, coordsFactor: 0.5, coordsInner: winWidth < 782, headers: true, timeAnnotation: 'timeNormal'})
      } else {
        pgnBoard = window.pgnEdit({inner: 'pgnBoard', moves: 'pgnMovesEvents', comment: 'pgnComment', button: 'pgnButtons', fen: 'pgnFen', error: 'pgnError'}, {width: Width, position: 'start', movesWidth: '80%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: 'white' /* window.orientationg */, coordsFactor: 0.5, coordsInner: winWidth < 782, headers: true, timeAnnotation: 'timeNormal'})
      }

      window.pgnBoardBase = pgnBoard.boardBase
      window.ground = pgnBoard.board
      /* var options = {
        fen: this.board.fen
      }
      window.ground.set(options)*/
      // document.getElementById('pgnBoard').style.height = Width + 'px'
      // document.getElementById('pgnBoard').style.width = Width + 'px'
      document.getElementById('pgnBoard').style.left = Left
      document.getElementById('analisisVertical').style.left = LeftAnalisis
      document.getElementById('analisisVertical').style.height = Width + 6 + 'px'
      // this.userFrom = ''
    },
    changePGN () {
      // var idTextArea = document.getElementById('idTextAreaPGN')
      // if (idTextArea && idTextArea.value !== 'none') {
      // window.alert('changePGN: ' + this.myPGNValue + ' FEN - ' + this.myFENValue)
      // comunicacion con servidor
      // if (UserService.getUser().username !== this.board.userWhite) {
      var turn = (this.chess.turn() === 'w') ? 'white' : 'black'
      var data = {
        c: 'board',
        f: 'move',
        data: {
          event: 'move',
          data: {
            urls: this.board.urls,
            pgn: this.myPGNValue,
            fen: this.myFENValue,
            idBoard: this.board._id,
            turn: turn,
            times: {},
            user: UserService.getUser()
            /* move: {
              from: '',
              to: ''
            }*/
          }
        }
      }
      // window.alert('changePGN')
      this.$socket.emit('event', data, function (...callbacks) {
        // console.log(callbacks)
      })
      // this.chess.load_pgn(this.myPGNValue)
      // this.soundPlay()
    // }
      // this.$dispatch('move', {pgn: this.myPGNValue})
      // }
    },
    isOwner () {
      return this.user.username === this.board.u1 || this.user.username === this.board.u2
    },
    countDown () {
      clearInterval(timesColor[this.turn])
      timesColor[this.turn] = setInterval(function () {
        this.times[this.turn] = this.times[this.turn] - 1
        if (this.times[this.turn] <= 0) {
          clearInterval(timesColor.white)
          clearInterval(timesColor.black)
          this.times[this.turn] = 0
        }
      }.bind(this), 1000)
    },
    chessToColor (chess) {
      var t = chess.turn()
      this.turn = (t === 'w') ? 'white' : 'black'
    },
    getRandomInt (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    loadDataGame (board) {
      // clearTimeout(window.computerGame)
      // window.alert(this.boardShow._id + ' ' + board._id)
      clearInterval(timesColor.white)
      clearInterval(timesColor.black)
      // cuando se esta visualizando un juego terminado
      this.boardShow = board
      if (board && board.wins) {
        // console.log('visualizando juego terminado')
        this.boardShow = board
        // this.historyChange = true
        this.changeStateGame(board)
        // window.prettyPrint()
        this.$nextTick(function () {
          var buttonLast = document.getElementById('pgnButtonslast')
          if (buttonLast) {
            buttonLast.click()
            if (document.getElementById('searchInput')) {
              document.getElementById('searchInput').value = this.myFENValue
              if (document.getElementById('analisisModal').style.display !== 'none') {
                document.getElementById('searchInput').dispatchEvent(new window.Event('change'))
              }
            }
          }
        })
        return
      }
      // Torneos
      if (board && board.type === 'torneo') {
        // window.alert('torneo')
        this.boardShow = board
        this.changeStateGame(board)
        this.$nextTick(function () {
          var buttonLast = document.getElementById('pgnButtonslast')
          if (buttonLast) {
            buttonLast.click()
            if (document.getElementById('searchInput')) {
              document.getElementById('searchInput').value = this.myFENValue
              if (document.getElementById('analisisModal').style.display !== 'none') {
                document.getElementById('searchInput').dispatchEvent(new window.Event('change'))
              }
            }
          }
          // this.countDown()
        })
      } else {
        var data = {
          c: 'board',
          f: 'getBoard',
          data: board
        }
        // board.pgn = '1.e4 e5 2.Nf3 Nc6 3.Bc4 Bc5 4.b4 { This is the Evans Gambit in the Giuco Piano, a violent opening leading to attacks that was popular in Anderssens time. } 4...Bxb4 { Accepting gambits was a manly thing to do } 5.c3 Ba5 6.d4 { Gaining more time } 6...exd4 7.O-O d3 { Wasting time } 8.Qb3 { Threatening Bxf7 } 8...Qf6 9.e5 Qg6 { Black does not capture because he would open the e-file } 10.Re1! Nge7 11.Ba3 b5 { Trying to counterattack?! } 12.Qxb5 Rb8 13.Qa4 Bb6 14.Nbd2 Bb7 15.Ne4 Qf5 { Note that the king is still stuck in the center } 16.Bxd3 { Threatening a discovery with Nd6+, winning the queen } 16...Qh5 17.Nf6+ { Forces a capture of the knight. After gxf6 exf6, white rooks will be able to attack down the e-file at blacks exposed king. That is why you have to castle early! } 17...gxf6 18.exf6 Rg8 19.Rad1! { Getting another rook in the fight. } 19...Qxf3 { Oh no! Black threatens mate by Qxg2 and the g pawn is pinned. } 20.Rxe7+ Nxe7 { Forced checkmate for white now } 21.Qxd7+!! { White has to keep on checking since black is threatening mate. } 21...Kxd7 ( 21...Kf8 22.Qxe7# ) 22.Bf5+ { The king has to move because of double check } 22...Ke8 { Now can you see it? } ( 22...Kc6 { allows an immediate } 23.Bd7# ) 23.Bd7+ Kf8 ( { or } 23...Kd8 ) 24.Bxe7# { Mate!! }  1-0'
        // window.alert(board.pgn)
        this.$socket.emit('event', data, function (...callbacks) {
          if (!callbacks[0]) {
            var board = callbacks[1].board
            this.boardShow = board
            this.times = callbacks[1].times
            // this.historyChange = true
            this.changeStateGame(board)
            this.$nextTick(function () {
              var buttonLast = document.getElementById('pgnButtonslast')
              if (buttonLast) {
                buttonLast.click()
              }
            })
            this.countDown()
          } else {
            return
            /*
            this.boardShow = {
              u1: 'Computer1',
              u2: 'Computer2'
            }
            // console.log('pc VS pc')
            // this.pcVsPcInit()
            document.getElementById('pgnMovesEvents').textContent = ''
            document.getElementById('pgnButtons').textContent = ''
            document.getElementById('pgnHeader').textContent = ''
            document.getElementById('pgnError').textContent = ''
            var Width = document.getElementById('middle').clientWidth
            // ../../../static/1.pgn
            var chosenNumber = this.getRandomInt(1, 5)
            window.pgnView({inner: 'pgnBoard', moves: 'pgnMovesEvents', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError'}, {pgnFile: '../../../static/' + chosenNumber + '.pgn', movesWidth: '80%', startPlay: 1, showFen: false, colorMarker: 'cm-small', width: Width, locale: 'es', orientation: window.orientationg, coordsFactor: 0.8, coordsInner: winWidth < 782, timerTime: 2000, autoplay: true, headers: true})
            // window.pgnView({inner: 'pgnBoard', moves: 'pgnMovesEvents', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError'}, {pgnFile: 'https:/www.zonetuner.com/' + chosenNumber + '.pgn', movesWidth: '80%', startPlay: 1, showFen: false, colorMarker: 'cm-small', width: Width, locale: 'es', orientation: window.orientationg, coordsFactor: 0.8, coordsInner: winWidth < 782, timerTime: 2000, autoplay: true, headers: true})
            var buttonLast = document.getElementById('pgnButtonslast')
            if (buttonLast) {
              buttonLast.click()
            }*/
          }
        }.bind(this))
      }
      // this.soundPlay()
    }
    /* FinishMoveCallback (move) {
      // var from = move & 0xFF
      // var to = (move >> 8) & 0xFF
      // var sfrom = Garbochess.FormatSquare(from)
      // var sto = Garbochess.FormatSquare(to)
      /* this.chess.move({
        from: sfrom,
        to: sto,
        promotion: 'q'
      })*
      document.getElementById('pgnMovesEvents').textContent = ''
      document.getElementById('pgnButtons').textContent = ''
      document.getElementById('pgnHeader').textContent = ''
      document.getElementById('pgnError').textContent = ''
      var Width = document.getElementById('middle').clientWidth
      var pgnBoard = 0
      if (this.board.pgn !== 'none') {
        pgnBoard = window.pgnEdit({inner: 'pgnBoard', moves: 'pgnMovesEvents', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError'}, {pgn: this.board.pgn, movesWidth: '80%', showFen: true, colorMarker: 'cm-small', width: Width, startPlay: this.chess.fen(), locale: 'es', orientation: window.orientationg, coordsFactor: 0.8, coordsInner: winWidth < 782, headers: true, timeAnnotation: 'timeNormal'})
      } else {
        pgnBoard = window.pgnEdit({inner: 'pgnBoard', moves: 'pgnMovesEvents', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError'}, {width: Width, movesWidth: '80%', showFen: true, colorMarker: 'cm-small', position: 'end', locale: 'es', orientation: window.orientationg, coordsFactor: 0.8, coordsInner: winWidth < 782, headers: true, timeAnnotation: 'timeNormal'})
      }
      window.pgnBoardBase = pgnBoard.boardBase
      window.ground = pgnBoard.board
      if (document.getElementById('middle')) {
        document.getElementById('pgnBoard').style.height = Width + 'px'
        document.getElementById('pgnBoard').style.width = Width + 'px'
        document.body.dispatchEvent(new window.Event('chessground.resize'))
      }
      // window.ground.move(sfrom, sto)
      var fen = this.chess.fen()
      var options = {
        animation: false,
        orientation: window.orientationg,
        fen: fen,
        highlight: {
          lastMove: true,       // add last-move class to squares
          check: true          // add check class to squares
        },
        drawable: {
          enabled: true, // can draw
          visible: true
        },
        movable: {
          free: false, // all moves are valid - board editor
          color: 'both', // color that can move. "white" | "black" | "both" | null
          dests: {}, // valid moves. {a2: ["a3", "a4"], b1: ["a3", "c3"]} | null
          dropOff: 'revert', // when a piece is dropped outside the board. "revert" | "trash"
          showDests: true // add the move-dest class to squares
        },
        /* premovable: {
          enabled: true,
          showDests: true,
          current: ['e2', 'e4']         // keys of the current saved premove ["e2", "e4"] | null
        }, *
        resizable: true
      }
      window.ground.set(options)
      /* this.ground.setAutoShapes([{
        orig: sfrom,
        dest: sto,
        brush: 'blue'
      }, {
        orig: 'e2',
        dest: 'b3',
        brush: 'red'
      }]) *
      this.chessToColor(this.chess)
      if (this.$route.path === '/home') {
        if (!this.chess.game_over()) {
          window.computerGame = setTimeout(function () {
            this.timerfunction(fen)
          }.bind(this), 10000)
        } else {
          clearTimeout(window.computerGame)
        }
      }
      if (document.getElementById('searchInput') && document.getElementById('analisisModal').style.display !== 'none') {
        window.onloadsimplechessboard()
        document.getElementById('searchInput').value = window.pgnBoardBase.chess.fen()
        // document.getElementById('searchInput').value = window.pgnBoardBase.getPgn().write_pgn()
        document.getElementById('searchInput').dispatchEvent(new window.Event('change'))
      }
    },*
    timerfunction (fen) {
      // window.alert(fen)
      // Garbochess.InitializeFromFen(fen)
      // Garbochess.Search(this.FinishMoveCallback, 7, null)
    },
    * pcVsPcInit () {
      // window.alert('')
      // Garbochess.ResetGame()
      /* setTimeout(function () {
        var fen = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
        this.timerfunction(fen)
      }.bind(this), 2000)*
    }*/
  },
  watch: {
    board (newVal, oldVal) {
      if (this.boardShow !== undefined && newVal !== oldVal) {
        this.loadDataGame(newVal)
        this.result = {
          wins: '',
          motiv: ''
        }
      }
    },
    /* boardFiles (newVal, oldVal) {
      this.getTorneos()
    },*/
    myPGNValue (val, oldVal) {
      // window.alert(' myPGNValue: ' + this.userFrom)
      // window.alert(JSON.stringify(this.board))
      // document.getElementById('myPGNValueP').textContent = val
      if (this.isOwner() && this.board.u1 === this.board.u2 && val !== oldVal) {
        // window.alert(' myPGNValue: ' + this.userFrom + this.boardShow.u1 + this.user.username)
        // this.sendPGNtoTeacher()
        this.changePGN()
      }
      // this.userFrom = this.user.username
      // window.alert('e' + this.userFrom)
    },
    myPGNTimeW (val, oldVal) {
      var a = val.split(':')
      var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2])
      // window.alert(seconds)
      this.times['white'] = seconds
      if (this.boardShow !== undefined && !this.boardShow.wins) {
        this.countDown()
      }
    },
    myPGNTimeB (val, oldVal) {
      var a = val.split(':')
      var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2])
      // window.alert(seconds)
      this.times['black'] = seconds
      if (this.boardShow !== undefined && !this.boardShow.wins) {
        this.countDown()
      }
    },
    myFENValue (val, oldVal) {
      if (document.getElementById('searchInput')) {
        document.getElementById('searchInput').value = val
        // document.getElementById('searchInput').value = window.pgnBoardBase.getPgn().write_pgn()
        document.getElementById('myFENValueP').textContent = val
        if (document.getElementById('analisisModal').style.display !== 'none') {
          document.getElementById('searchInput').dispatchEvent(new window.Event('change'))
        }
      }
      // window.alert(' myPGNValue: ' + this.userFrom)
      // window.alert(JSON.stringify(this.board.user))
      // window.alert(this.userFrom + '' + this.boardShow.u1)
      if (this.boardShow !== undefined && this.board.u1 === this.board.u2 && val !== oldVal && this.userFrom !== this.boardShow.u1 && this.userFrom === this.user.username) {
        // window.alert(' myFENValue: ' + this.userFrom + this.boardShow.u1 + this.user.username)
        // this.sendPGNtoTeacher()
      }
      if (window.pgnBoardBase.chess !== undefined) {
        this.turn = (window.pgnBoardBase.chess.turn() === 'w') ? 'white' : 'black'
      }
      // this.soundPlay()
      // this.userFrom = this.user.username
      // window.alert('e' + this.userFrom)
    },
    turn (newVal, oldVal) {
      clearInterval(timesColor[oldVal])
      clearInterval(timesColor[newVal])
      if (this.boardShow !== undefined && !this.boardShow.wins) {
        this.countDown()
      }
    },
    immediate: true
  },
  created () {
    window.addEventListener('resize', this.onResize)
    clearTimeout(window.computerGame)
    clearInterval(timesColor.white)
    clearInterval(timesColor.black)
    /* var options = {
      orientation: 'white',
      viewOnly: false,
      movable: {
        free: false, // all moves are valid - board editor
        color: 'both', // color that can move. "white" | "black" | "both" | null
        dests: {}, // valid moves. {a2: ["a3", "a4"], b1: ["a3", "c3"]} | null
        dropOff: 'revert', // when a piece is dropped outside the board. "revert" | "trash"
        showDests: true // add the move-dest class to squares
      },
      highlight: {
        lastMove: true,       // add last-move class to squares
        check: true          // add check class to squares
      },
      drawable: {
        enable: true,
        visible: true
      }
    }
    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']]
    /* this.$nextTick(function () {
      var Width = document.getElementById('middle').clientWidth
      var pgnBoard = window.pgnEdit({inner: 'pgnBoard', moves: 'pgnMovesEvents', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader'}, {width: Width, movesWidth: '80%', showFen: true, locale: 'es', colorMarker: 'cm-small', orientation: window.orientationg, coordsFactor: 0.8, coordsInner: winWidth < 782, headers: true, timeAnnotation: 'timeNormal'})
      window.pgnBoardBase = pgnBoard.boardBase
      if (document.getElementById('middle')) {
        document.getElementById('pgnBoard').style.height = Width + 'px'
        document.getElementById('pgnBoard').style.width = Width + 'px'
        document.body.dispatchEvent(new window.Event('chessground.resize'))
      }
      window.ground = pgnBoard.board
      window.ground.set(options)
      // window.ground = Chessground(document.getElementById('frontBoardVisor'), options)
      // var Width = document.getElementById('frontBoardVisor').clientWidth
      // document.getElementById('frontBoardVisor').style.height = Width + 'px'
      // document.getElementById('frontBoardVisor').style.width = Width + 'px'
      // document.getElementById('pgnBoard').style.height = Width + 'px'
      // document.getElementById('pgnBoard').style.width = Width + 'px'

      // getFromLocalStorage
      this.loadDataGame(this.board)
    })*/
  }
}
</script>

<style scoped>
  @import '../../../static/libs/simplechessboard.min.css';
  .userTurn {
    color: white ;
    font-size: large;
  }
  .check {
    background: radial-gradient(ellipse at center, rgb(123, 255, 0) 40%, rgba(231, 0, 0, 1) 40%, rgba(169, 0, 0, 0) 89%, rgba(158, 0, 0, 0) 100%);
  }
  .loadbar:before {
  content: "";
  margin-top: -3px;
  
  width: calc(100% - 0px);
  /* height: calc(100% + 6px);
  position: absolute;*/
  z-index: 6;
 
}
  .loadbar
    {
      top: -3px;
         width:15px;
         background-color: #5c005c; /*var(--thumbBG);*/
         position:relative;
         float:left;
         border:1px solid;
        
    }
    .bar
    {
        width:100%;
        display:block;        
        font-family:arial;
        font-size:12px; 
        background-color:white;
        color:#000;       
        position:absolute;
        bottom:0;        
    }
</style>



// WEBPACK FOOTER //
// boardVisorEvents.vue?024ba09a